﻿import { IApprover } from "@/interfaces";

const filterDependentApprovers = (
  approvers: IApprover[],
  parentExcludeApprovers: IApprover[]
): void => {
  parentExcludeApprovers.push(...approvers);
  approvers.forEach(({ dependantApprovers }) => {
    if (!dependantApprovers) return;

    filterDependentApprovers(dependantApprovers, parentExcludeApprovers);
  });
};

export const flattenApprovers = (approvers: IApprover[]): IApprover[] => {
  const parentExcludeApprovers: IApprover[] = [];

  if (!approvers) return approvers;

  approvers.forEach((approver) => {
    parentExcludeApprovers.push(approver);

    const { dependantApprovers } = approver;

    if (!dependantApprovers) return;

    filterDependentApprovers(dependantApprovers, parentExcludeApprovers);
  });

  return parentExcludeApprovers;
};
